import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { SimilarCandidateService } from '../_services/similar-candidate.service';

export type SCPassData = { data: SimilarCandidateDetails, calledfrom: string };

@Component({
  selector: 'app-ai-modal-sc',
  templateUrl: './ai-modal-sc.component.html',
  styleUrls: ['./ai-modal-sc.component.scss']
})
export class AiModalScComponent implements OnInit {

  progressValue = 0;
  @Input() public similarCandidateData : SCPassData;

  constructor(private activeModal: NgbActiveModal, private similarCandidateService: SimilarCandidateService,
    private modalService: NgbModal) { }

  ngOnInit() { this.increaseProgress(); }

  private increaseProgress() {
    const interval$ = interval(1000); 
    const subscription = interval$.subscribe(() => {
      this.progressValue += 20;
      if (this.progressValue > 100) {
        subscription.unsubscribe();
        this.activeModal.close(this.similarCandidateData);
        this.modalService.dismissAll();
        // We don't need to emit this event if we are coming from listing page
        this.similarCandidateData.calledfrom !== "view-similar-candidate" && 
          this.similarCandidateService.emitScLoaderDataEvent(this.similarCandidateData);
      }
    });
  }

}
